<ion-item [lines]="lines">
  <ion-label class="ion-text-wrap" [position]="labelPosition">{{ titel | translate }}</ion-label>

  <div [slot]="inputSlot" class="input-outer">

    <div class="select-container" [class.with-button]="inputWithButton" *ngIf="!readOnly">
      <ion-select
                  [placeholder]="placeholder"
                  [class.input-upper-case]="uppercase"
                  [class.invalid-value]="isInvalid"
                  [class.input-readonly]="readOnly"
                  [disabled]="disabled"
                  [(ngModel)]="myValue"
                  (ionChange)="onBlur($event)"
                  [okText]="'OK' | translate"
                  [cancelText]="'Abbrechen' | translate"
                  #select>

        <ng-container *ngIf="!valueExpr && !textExpr">
          <!-- Einfache Werte, z.B. eine Liste mit Strings oder Zahlen -->
          <ion-select-option *ngFor="let p of listItems" [value]="p" [class.favorite]="p.istFavorite">{{ p }}</ion-select-option>
        </ng-container>

        <ng-container *ngIf="!valueExpr && textExpr">
          <!-- Text-Expression ist angegeben, als Value soll das Objekt selbst verwendet werden. -->
          <ion-select-option *ngFor="let p of listItems" [value]="p" [class.favorite]="p.istFavorite">{{ p[textExpr] }}</ion-select-option>
        </ng-container>

        <ng-container *ngIf="valueExpr">
          <ion-select-option *ngFor="let p of listItems" [value]="p[valueExpr]" [class.favorite]="p.istFavorite">{{ p[textExpr] }}</ion-select-option>
        </ng-container>
      </ion-select>
    </div>

    <ion-input
               *ngIf="readOnly"
               type="text"
               [class.input-readonly]="true"
               [class.with-button]="inputWithButton"
               [readonly]="true"
               [ngModel]="myTextValue"
               class="input-readonly-text"
               #input></ion-input>

    <ion-button *ngIf="isClearButtonVisible"
                class="clear-button inline-plusminus-button"
                [disabled]="disabled"
                appClick (clicked)="onClearValue()"
                size="default"
                color="light"
                slot="end">
      <ion-icon name="close-outline" mode="ios" class="clear-icon"></ion-icon>
    </ion-button>


    <div class="buttons" *ngIf="!isExtraButtonZeile">
      <ion-button *ngIf="scanNfcButton"
                  [disabled]="disabled"
                  class="nfc-button inline-plusminus-button"
                  appClick (clicked)="scanNfc()"
                  size="default"
                  color="light"
                  slot="end">NFC</ion-button>

    </div>
  </div>

</ion-item>


<!-- <ion-item lines="none" *ngIf="beifahrer2Auswaehlbar">
  <ion-label position="stacked">{{ 'Beifahrer2' | translate }}</ion-label>

  <ion-select placeholder="{{ 'Bitte Beifahrer2 wählen' | translate }}" formControlName="beifahrer2" [okText]="'OK' | translate" [cancelText]="'Abbrechen' | translate">
    <ion-select-option *ngFor="let p of beifahrerListe" [value]="p.Key" [class.favorite]="p.istFavorite">{{ p.anzeigeName }}</ion-select-option>
  </ion-select>
</ion-item> -->